import PropTypes from 'prop-types';

const SendSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 24}`}
      height={`${height || 24}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M9.50733 4.23L18.0673 8.51C21.9073 10.43 21.9073 13.57 18.0673 15.49L9.50733 19.77C3.74733 22.65 1.39733 20.29 4.27733 14.54L5.14733 12.81C5.39733 12.3 5.39733 11.71 5.14733 11.2L4.27733 9.46C1.39733 3.71 3.75733 1.35 9.50733 4.23Z"
        fill={color}
      />
      <path
        d="M14.8375 12.75H9.4375C9.0275 12.75 8.6875 12.41 8.6875 12C8.6875 11.59 9.0275 11.25 9.4375 11.25H14.8375C15.2475 11.25 15.5875 11.59 15.5875 12C15.5875 12.41 15.2475 12.75 14.8375 12.75Z"
        fill={color}
      />
    </svg>
  );
};

SendSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default SendSvg;
